// Generated types for InterfaceExpansionTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { IntrinsicExpansionTaskReadAPI, IntrinsicExpansionTaskWriteAPI } from './intrinsicexpansiontask';
import { IntrinsicExpansionTaskReadAPISchemaObject, IntrinsicExpansionTaskWriteAPISchemaObject } from './intrinsicexpansiontask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface InterfaceExpansionTaskReadAPI extends IntrinsicExpansionTaskReadAPI {
}

export interface InterfaceExpansionTaskWriteAPI extends IntrinsicExpansionTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const InterfaceExpansionTaskReadAPISchema: z.ZodType<InterfaceExpansionTaskReadAPI> = IntrinsicExpansionTaskReadAPISchemaObject.extend({}).passthrough();

export const InterfaceExpansionTaskWriteAPISchema: z.ZodType<InterfaceExpansionTaskWriteAPI> = IntrinsicExpansionTaskWriteAPISchemaObject.extend({}).passthrough();
